import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { syncBlockMessages as messages } from '@atlaskit/editor-common/messages';
import ModalDialog, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { Text } from '@atlaskit/primitives/compiled';
export var DeleteConfirmationModal = function DeleteConfirmationModal(_ref) {
  var syncBlockStoreManager = _ref.syncBlockStoreManager,
    api = _ref.api;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    syncBlockCount = _useState4[0],
    setSyncBlockCount = _useState4[1];
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['connectivity'], function (states) {
      var _states$connectivityS;
      return {
        mode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode
      };
    }),
    mode = _useSharedPluginState.mode;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var resolverRef = React.useRef(undefined);
  var handleClose = useCallback(function (confirm) {
    return function () {
      if (resolverRef.current) {
        resolverRef.current(confirm);
        resolverRef.current = undefined;
      }
      setIsOpen(false);
    };
  }, []);
  var confirmationCallback = useCallback(function (syncBlockCount) {
    setIsOpen(true);
    setSyncBlockCount(syncBlockCount);
    var confirmedPromise = new Promise(function (resolve) {
      resolverRef.current = resolve;
    });
    return confirmedPromise;
  }, []);
  useEffect(function () {
    var unregister = syncBlockStoreManager.sourceManager.registerConfirmationCallback(confirmationCallback);
    return function () {
      unregister();
    };
  }, [syncBlockStoreManager, confirmationCallback]);
  return /*#__PURE__*/React.createElement(ModalTransition, null, isOpen && /*#__PURE__*/React.createElement(ModalDialog, {
    onClose: handleClose(false)
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    hasCloseButton: true
  }, /*#__PURE__*/React.createElement(ModalTitle, {
    appearance: "warning"
  }, formatMessage(messages.deleteConfirmationModalTitle))), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Text, null, formatMessage(messages.deleteConfirmationModalDescription, {
    syncBlockCount: syncBlockCount
  }))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    onClick: handleClose(false)
  }, formatMessage(messages.deleteConfirmationModalCancelButton)), /*#__PURE__*/React.createElement(Button, {
    appearance: "warning",
    onClick: handleClose(true),
    autoFocus: true,
    isDisabled: mode === 'offline'
  }, formatMessage(messages.deleteConfirmationModalDeleteButton)))));
};